import * as React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useLayout } from '../hooks/layout';
import { useAuth } from '../hooks/auth';
import Img from './Img';
import Search from './Search';
import Sidebar from './Sidebar';
import { AppBar, Box, Toolbar, IconButton, Typography, Button, ButtonBase, Avatar, Collapse } from '@mui/material';
import logoImg from '../assets/icons/ciclogo.svg';
import { UserIcon, SearchIcon, BurgerIcon } from '../shared/Icons';

const Header = () => {

  const {isMobile} = useLayout();
  const location = useLocation();
  const {auth, user} = useAuth();
  const [openSearch, setOpenSearch] = React.useState(false);
  const [openSidebar, setOpenSidebar] = React.useState(false);

  React.useEffect(() => {
    setOpenSearch(false);
  }, [location.pathname])

  return (
      <AppBar
        color="white" 
        position="fixed"
        sx={{
          py:{
            xs: 1,
            borderRadius: 0,
            overflow: 'visible'
          }
        }}
      >
        <Toolbar>
          <Box
            width="40%"
            maxWidth={275}
            mr={2}
          >
            <ButtonBase
              component={NavLink}
              to="/"
            >
              <Img 
                src={logoImg} 
                sx={{
                  width: '100%',
                  maxHeight: 65       
                }} 
              />
            </ButtonBase>
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Search id="search-autocomplete" />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box>
            <IconButton
              size="small"
              color="dark"
              sx={{
                mr: 3,
                display: {
                  md: 'none'
                }
              }}
              onClick={() => setOpenSearch(!openSearch)}
            >
              <SearchIcon color="inherit" fontSize="inherit" />
            </IconButton>
            {
              user ?
              <>
                <Button
                  component={NavLink}
                  to="/user"
                  size="large"
                  variant="text"
                  color="dark"
                  sx={{
                    mr: 3,
                    display: {
                      xs: 'none',
                      md: 'inline-flex'
                    }
                  }}
                  endIcon={
                    <Avatar 
                      variant="rounded"
                      src={user.avatar.url} 
                      sx={{
                        borderRadius: '38px'
                      }}
                    />
                  }
                >
                  {user.first_name} 
                </Button>
                <IconButton
                  component={NavLink}
                  to="/user"
                  size="small"
                  color="dark"
                  sx={{
                    mr: 3,
                    display: {
                      md: 'none'
                    }
                  }}
                >
                  <Avatar 
                    variant="rounded"
                    src={user.avatar.url}
                    sx={{
                      borderRadius: '26px'
                    }} 
                  />
                </IconButton>
              </> :
              <>
                <Button
                  component={NavLink}
                  to="/auth/login"
                  size="large"
                  variant="text"
                  color="dark"
                  sx={{
                    mr: 3,
                    display: {
                      xs: 'none',
                      md: 'inline-flex'
                    }
                  }}
                  endIcon={
                    <UserIcon 
                      sx={{
                        fontSize: '2.5rem !important'
                      }} 
                    />
                  }
                >
                  Accedi 
                </Button>
                <IconButton
                  component={NavLink}
                  to="/auth/login"
                  size="small"
                  color="dark"
                  sx={{
                    mr: 3,
                    display: {
                      md: 'none'
                    }
                  }}
                >
                  <UserIcon 
                    sx={{
                      fontSize: '1.9rem !important'
                    }} 
                  />
                </IconButton>
              </>
            }
            <IconButton
              size={isMobile ? 'small' : 'medium'}
              color="dark"
              onClick={() => setOpenSidebar(true)}
            >
              <BurgerIcon fontSize="inherit" />
            </IconButton>
            <Sidebar open={openSidebar} setOpen={setOpenSidebar} />
          </Box>
        </Toolbar>
        <Collapse 
          in={openSearch} 
          sx={{
            display: {
              md: 'none'
            }
          }}
        >
          <Box
            px={2}
          >
            <Search id="search-autocomplete-mobile" />
          </Box>
        </Collapse>
      </AppBar>
  );
}

export default Header;
